import { render, staticRenderFns } from "./ProductSelect.vue?vue&type=template&id=74520bf5&scoped=true&"
import script from "./ProductSelect.vue?vue&type=script&lang=js&"
export * from "./ProductSelect.vue?vue&type=script&lang=js&"
import style0 from "./ProductSelect.vue?vue&type=style&index=0&id=74520bf5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74520bf5",
  null
  
)

export default component.exports